import { extendTheme } from '@chakra-ui/react'
import { buttonTheme } from './chakra/button'
import { cardTheme } from './chakra/card'
import { checkboxTheme } from './chakra/checkbox'
import { formLabelTheme } from './chakra/form-label'
import { inputTheme } from './chakra/input'
import { modalTheme } from './chakra/modal'
import { numberInputTheme } from './chakra/number-input'
import { radioTheme } from './chakra/radio'
import { selectTheme } from './chakra/select'
import { textareaTheme } from './chakra/textarea'

// 2. Call `extendTheme` and pass your custom values
export const theme = extendTheme({
  components: {
    Button: buttonTheme,
    Card: cardTheme,
    Checkbox: checkboxTheme,
    Input: inputTheme,
    Modal: modalTheme,
    Select: selectTheme,
    FormLabel: formLabelTheme,
    NumberInput: numberInputTheme,
    Radio: radioTheme,
    Textarea: textareaTheme
  }
})
